import { FormattedMessage } from 'react-intl'
import Info from 'components/shared/Info'
import Box from 'components/shared/Box'

const TicketsWithAccommodationInCartPromoInfo = () => (
    <Box isFullWidth>
        <Info color="success" align={['flex-start', 'center']}>
            <FormattedMessage
                id="promo.accommodation_tickets_cart_promo_info"
                defaultMessage="Dodaj bilet do koszyka - zniżka dla gości Suntago Village naliczy się automatycznie."
            />
        </Info>
    </Box>
)

export default TicketsWithAccommodationInCartPromoInfo
